import styles from './Header.module.scss';

export function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <h1 className={styles.title}>GTB - Building Management System</h1>
        <nav className={styles.nav}>
          {/* Navigation items will be added */}
        </nav>
      </div>
    </header>
  );
}
